import { render } from "./MBreadcrumb.vue?vue&type=template&id=3f6fdd5e"
import script from "./MBreadcrumb.vue?vue&type=script&lang=js"
export * from "./MBreadcrumb.vue?vue&type=script&lang=js"

import "./MBreadcrumb.vue?vue&type=style&index=0&id=3f6fdd5e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__